import React from 'react';
import PropTypes from 'prop-types';

import { post } from 'helpers/api';

import AddLeadsToProjectModal from 'components/modals/add_leads_to_project_modal';

export default class ContactAddProjectLeadButton extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      id: PropTypes.number.isRequired,
      contactType: PropTypes.oneOf([
        "Contacts::Company",
        "Contacts::Person"
      ]).isRequired
    }).isRequired,
    label: PropTypes.any,
    leadStatuses: PropTypes.array.isRequired,
    referralSources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })),
    onAdd: PropTypes.func.isRequired
  };

  static defaultProps = {
    label: 'Add Project Lead'
  };

  state = { shown: false };

  handleAddProjectLead = (projectId, status, projectsLeadReferralSourceId) => {
    const { contact, onAdd } = this.props;
    const leadData = {
      contactId: contact.id,
      contactType: contact.contactType,
      projectsLeadStatusId: status.id,
      projectsLeadReferralSourceId
    };
    const path = `/projects/${projectId}/leads.json`;

    return post(path, leadData).then((data) => {
      onAdd(data);
      this.handleEndAddProjectLead();
      return data;
    });
  };

  handleStartAddProjectLead = () => this.setState({ shown: true });
  handleEndAddProjectLead = () => this.setState({ shown: false });

  render() {
    const { contact, label, leadStatuses, referralSources, onAdd, ...props } = this.props;
    const { shown } = this.state;

    return (
      <React.Fragment>
        <button {...props} name="add-project-lead-button" type="button" onClick={this.handleStartAddProjectLead}>
          {label}
        </button>
        <AddLeadsToProjectModal
          leadStatuses={leadStatuses}
          referralSources={referralSources}
          selectedContactCount={1}
          shown={shown}
          onCancel={this.handleEndAddProjectLead}
          onSubmit={this.handleAddProjectLead}
        />
      </React.Fragment>
    );
  }
}
